import React, {lazy, ReactNode, Suspense, useEffect, useState, useTransition} from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {CenterBox} from "@pg-design/grid-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {useRoutedModalState} from "../../../../hooks/use_routed_modal_state";
import {useOfferBuildings} from "../../../../hooks/useOfferBuildings";
import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {gtmEvent3DMockup} from "../../../../tracking/google_tag_manager/gtm_event_3d_mockup";
import {PLANNER_3D_SEARCH_PARAM} from "../../constants/planner_3d_params";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";

interface Props {
    className?: string;
    children: ReactNode;
    modalId: string;
    offer: IMakeablePlansOffer;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

const PlannerFloor = lazy(() => import(/* webpackChunkName: "lazy_planner_floor_chunk" */ "./PlannerFloor"));
const PlannerProperty = lazy(() => import(/* webpackChunkName: "lazy_planner_property_chunk" */ "./PlannerProperty"));

const DEFAULT_FLOOR_KEY = "0";

export const Planner3DImakeable = (props: Props) => {
    const {openModal, closeModal, modalState} = useRoutedModalState(PLANNER_3D_SEARCH_PARAM, props.modalId);
    const [_, startTransition] = useTransition();
    const [currentFloor, setCurrentFloor] = useState<string | undefined>();
    const [currentProperty, setCurrentProperty] = useState<IPropertyListProperty | null>(null);
    const [currentBuilding, setCurrentBuilding] = useState<string | undefined>(undefined);

    const {offerBuildings, fetchOfferBuildings} = useOfferBuildings();

    useEffect(() => {
        fetchOfferBuildings(props.offer.id);
    }, [props.offer.id, fetchOfferBuildings]);

    useEffect(() => {
        if (modalState && offerBuildings && offerBuildings.length > 0) {
            const initialBuilding = props.initialBuildingUuid ? offerBuildings.find((b) => b.uuid === props.initialBuildingUuid) : offerBuildings[0];
            setCurrentBuilding(initialBuilding?.uuid);
            setCurrentFloor(props.initialFloor?.toString() || DEFAULT_FLOOR_KEY);
        }
    }, [offerBuildings, modalState]);

    const onModalClose = () => {
        closeModal();
        startTransition(() => {
            // using transition because we want this to happen after the modal closes
            setCurrentFloor(undefined);
            setCurrentProperty(null);
            setCurrentBuilding(undefined);
        });
    };

    const onButtonClick = () => {
        gtmEvent3DMockup("mockup_click");
        openModal();
    };

    return (
        <div className={props.className}>
            <div onClick={onButtonClick}>{props.children}</div>

            <Modal
                isOpen={modalState}
                shouldCloseOnOverlayClick
                showCloseButton
                closeButton={(closeModal) => <CloseIcon onClick={closeModal} fill="#000" size="2" />}
                css={modalStyle}
                onModalClose={() => onModalClose()}
            >
                <Modal.CloseButton placement="right" wrapperColor="#fff" size="1.6" css={closeButtonStyle} />
                <Suspense
                    fallback={
                        <CenterBox>
                            <Loader />
                        </CenterBox>
                    }
                >
                    {currentFloor && !currentProperty && currentBuilding && (
                        <PlannerFloor
                            offer={props.offer}
                            onBack={() => setCurrentFloor(undefined)}
                            currentFloor={currentFloor}
                            setCurrentFloor={setCurrentFloor}
                            setCurrentProperty={setCurrentProperty}
                            offerBuildings={offerBuildings}
                            currentBuilding={currentBuilding}
                            setCurrentBuilding={(value) => {
                                setCurrentBuilding(value);
                                setCurrentFloor(DEFAULT_FLOOR_KEY);
                            }}
                        />
                    )}

                    {currentProperty && <PlannerProperty property={currentProperty} onBack={() => setCurrentProperty(null)} />}
                </Suspense>
            </Modal>
        </div>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        width: 90vw;
        max-width: 1600px;
        height: 90vh;
        max-height: 1200px;
    }
`;

const closeButtonStyle = css`
    cursor: pointer;
    display: block;
    margin: 1rem;
    padding: 1rem;
    border-radius: 50%;
    ${elevation(2)}
`;
import React, {lazy, ReactNode, Suspense, useEffect, useState, useTransition} from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {CenterBox} from "@pg-design/grid-module";
import {CloseIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {useRoutedModalState} from "../../../../hooks/use_routed_modal_state";
import {useOfferBuildings} from "../../../../hooks/useOfferBuildings";
import {IPropertyListProperty} from "../../../../property/types/PropertyListProperty";
import {gtmEvent3DMockup} from "../../../../tracking/google_tag_manager/gtm_event_3d_mockup";
import {PLANNER_3D_SEARCH_PARAM} from "../../constants/planner_3d_params";
import {IMakeablePlansOffer} from "../../types/IMakeablePlansOffer";

interface Props {
    className?: string;
    children: ReactNode;
    modalId: string;
    offer: IMakeablePlansOffer;
    initialBuildingUuid?: string | null;
    initialFloor?: number | null;
}

const PlannerFloor = lazy(() => import(/* webpackChunkName: "lazy_planner_floor_chunk" */ "./PlannerFloor"));
const PlannerProperty = lazy(() => import(/* webpackChunkName: "lazy_planner_property_chunk" */ "./PlannerProperty"));

const DEFAULT_FLOOR_KEY = "0";

export const Planner3DImakeable = (props: Props) => {
    const {openModal, closeModal, modalState} = useRoutedModalState(PLANNER_3D_SEARCH_PARAM, props.modalId);
    const [_, startTransition] = useTransition();
    const [currentFloor, setCurrentFloor] = useState<string | undefined>();
    const [currentProperty, setCurrentProperty] = useState<IPropertyListProperty | null>(null);
    const [currentBuilding, setCurrentBuilding] = useState<string | undefined>(undefined);

    const {offerBuildings, fetchOfferBuildings} = useOfferBuildings();

    useEffect(() => {
        fetchOfferBuildings(props.offer.id);
    }, [props.offer.id, fetchOfferBuildings]);

    useEffect(() => {
        if (modalState && offerBuildings && offerBuildings.length > 0) {
            const initialBuilding = props.initialBuildingUuid ? offerBuildings.find((b) => b.uuid === props.initialBuildingUuid) : offerBuildings[0];
            setCurrentBuilding(initialBuilding?.uuid);
            setCurrentFloor(props.initialFloor?.toString() || DEFAULT_FLOOR_KEY);
        }
    }, [offerBuildings, modalState]);

    const onModalClose = () => {
        closeModal();
        startTransition(() => {
            // using transition because we want this to happen after the modal closes
            setCurrentFloor(undefined);
            setCurrentProperty(null);
            setCurrentBuilding(undefined);
        });
    };

    const onButtonClick = () => {
        gtmEvent3DMockup("mockup_click");
        openModal();
    };

    return (
        <div className={props.className}>
            <div onClick={onButtonClick}>{props.children}</div>

            <Modal
                isOpen={modalState}
                shouldCloseOnOverlayClick
                showCloseButton
                closeButton={(closeModal) => <CloseIcon onClick={closeModal} fill="#000" size="2" />}
                css={modalStyle}
                onModalClose={() => onModalClose()}
            >
                <Modal.CloseButton placement="right" wrapperColor="#fff" size="1.6" css={closeButtonStyle} />
                <Suspense
                    fallback={
                        <CenterBox>
                            <Loader />
                        </CenterBox>
                    }
                >
                    {currentFloor && !currentProperty && currentBuilding && (
                        <PlannerFloor
                            offer={props.offer}
                            onBack={() => setCurrentFloor(undefined)}
                            currentFloor={currentFloor}
                            setCurrentFloor={setCurrentFloor}
                            setCurrentProperty={setCurrentProperty}
                            offerBuildings={offerBuildings}
                            currentBuilding={currentBuilding}
                            setCurrentBuilding={(value) => {
                                setCurrentBuilding(value);
                                setCurrentFloor(DEFAULT_FLOOR_KEY);
                            }}
                        />
                    )}

                    {currentProperty && <PlannerProperty property={currentProperty} onBack={() => setCurrentProperty(null)} />}
                </Suspense>
            </Modal>
        </div>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        width: 90vw;
        max-width: 1600px;
        height: 90vh;
        max-height: 1200px;
    }
`;

const closeButtonStyle = css`
    cursor: pointer;
    display: block;
    margin: 1rem;
    padding: 1rem;
    border-radius: 50%;
    ${elevation(2)}
`;
